import React, { memo } from "react";
import type { Element } from "slate";
import { useSlate } from "slate-react";

import { Helpers } from "../helpers";
import { NodeTypes } from "../slateTypes";

export interface IProps {
  format: NodeTypes;
  children: React.ReactNode;
}
const ListButton: React.FC<IProps> = memo(({ format, children }) => {
  const editor = useSlate();
  const isActive = Helpers.getListType(editor) === format;
  const isCodeActive = Helpers.isElement(editor, NodeTypes.BLOCK_CODE);
  const activeBlock = Helpers.getActiveBlock(editor);
  let isDisabled =
    (activeBlock
      ? (activeBlock[0] as Element).type === NodeTypes.HEADING
      : false) || isCodeActive;

  return (
    <button
      className={`editor-toolbar__button ${isActive ? "active" : ""}`}
      onMouseDown={event => {
        event.preventDefault();
        Helpers.toggleList(editor, format);
      }}
      disabled={isDisabled}
    >
      {children}
    </button>
  );
});

export { ListButton };
